import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import OptionStatistic from './OptionStatistic';
import onwardPlacementForm from '../../../clients/detail/fhbfForm/interventionCenter/onwardPlacementForm';
import { CounselingCenterStatistics } from '../../../common/types/statistics/fhbfStatistics';

type Props = {
  statistics: CounselingCenterStatistics;
};

function ReferralStatistics({ statistics }: Props) {
  return (
    <Stack direction='column'>
      <Typography fontWeight='bold'>Weitervermittlung und Weiterempfehlung</Typography>
      <Typography>
        Davon direkte fallbezogene Kontaktaufnahme durch die IST zu anderer Einrichtung:{' '}
        {statistics.numberOfOnwardPlacementDirectContact}
      </Typography>
      <Typography>Davon nur Weitergabe der Kontaktdaten: {statistics.numberOfOnwardPlacementContactDetails}</Typography>
      <Typography>Beides: {statistics.numberOfBothOnwardPlacement}</Typography>
      <OptionStatistic
        fieldKey='onwardPlacement'
        fields={onwardPlacementForm.fields}
        statistic={statistics.onwardPlacement}
      />
    </Stack>
  );
}

export default ReferralStatistics;
